import {
  Scissors,
  UserRound,
  Zap,
  Wind,
  Droplets,
  Droplet,
  Eye,
  ArrowUp,
  Baby,
  Palette,
  Sparkles,
  Crown,
} from "lucide-react";

// Menzy's WhatsApp number (Bahamas +1 242). Configurable in one place.
export const WHATSAPP_NUMBER = "12428029333";
export const WHATSAPP_DISPLAY = "(242) 802-9333";

// $5 automatically added to any online appointment booking.
export const BOOKING_FEE = 5;

// Social links — leave blank until real URLs are supplied (no fake links).
export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/trapmenzy06",
  tiktok: "https://www.tiktok.com/@menzy006",
  facebook: "https://www.facebook.com/trap.menzy",
};

export const SERVICES = [
  { id: "regular-haircut", name: "Regular Haircut", price: 15, desc: "Clean cut. Fresh look.", icon: Scissors },
  { id: "haircut-beard", name: "Haircut + Beard", price: 20, desc: "The complete fresh look.", icon: UserRound },
  { id: "fades", name: "Fades", price: 15, desc: "Sharp. Clean. Stylish.", icon: Zap },
  { id: "blow-out", name: "Blow-Out", price: 15, desc: "Add volume and style.", icon: Wind },
  { id: "senior-citizen", name: "Senior Citizen", price: 20, desc: "Respect always. 60 & over.", icon: UserRound },
  { id: "hot-towel-shave", name: "Hot Towel Shave", price: 10, desc: "Smooth & refreshing.", icon: Droplets },
  { id: "eyebrows", name: "Eyebrows", price: 8, desc: "Clean and sharp.", icon: Eye },
  { id: "shape-up", name: "Shape Up", price: 10, desc: "Keep it neat.", icon: ArrowUp },
  { id: "beard-trim", name: "Beard Trim", price: 10, desc: "Sharp beard. Clean lines.", icon: Scissors },
  { id: "kids-cuts", name: "Kids Cuts — 11 & Under", price: 10, desc: "Fresh cuts for the young ones.", icon: Baby },
  { id: "designs", name: "Designs", price: 5, desc: "Add your own style.", icon: Palette },
  { id: "shampoo", name: "Shampoo", price: 10, desc: "Clean start. Fresh finish.", icon: Droplet },
];

export const DEALS = [
  {
    id: "deal-cut-eyebrows",
    name: "Regular Cut + Eyebrows",
    price: 15,
    desc: "Clean cut. Sharp brows.",
    isDeal: true,
    icon: Sparkles,
  },
  {
    id: "deal-cut-eyebrows-beard",
    name: "Regular Cut + Eyebrows + Beard",
    price: 25,
    desc: "The complete package.",
    isDeal: true,
    icon: Crown,
  },
];

export const ALL_BOOKABLE = [...SERVICES, ...DEALS];

export const GALLERY = [
  { title: "Clean Line Ups", src: "/assets/work_1.png" },
  { title: "Fresh Cuts", src: "/assets/work_2.png" },
  { title: "Stylish Looks", src: "/assets/work_3.png" },
  { title: "Sharp & Clean", src: "/assets/work_4.png" },
];

// Build a wa.me url with a pre-filled message.
export function whatsappUrl(text) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
}

export function openWhatsApp(text) {
  window.open(whatsappUrl(text), "_blank", "noopener,noreferrer");
}
